module.exports = __webpack_public_path__ + "img/syrenis-black.e889b107.png";